import { render } from "./SignIn2.vue?vue&type=template&id=709eb78a"
import script from "./SignIn2.vue?vue&type=script&lang=js"
export * from "./SignIn2.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\na-doskah.ru\\crm.na-doskah.ru.v1.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__